import {
  PendingDocumentsState,
  PendingProjectSettings
} from './pending-documents.state';
import { PendingDocumentSettingsDto as PendingDocumentSettings } from '@/jbi-shared/types/full-document-revision-object.types';

export const pendingDocumentsMutations = {
  // Document settings mutations
  GET_DOCUMENT_SETTINGS_LOADING(state: PendingDocumentsState) {
    state.apiState.getDocumentSettings.loading = true;
    state.apiState.getDocumentSettings.success = false;
    state.apiState.getDocumentSettings.error = null;
  },
  GET_DOCUMENT_SETTINGS_SUCCESS(
    state: PendingDocumentsState,
    {
      documentId,
      settings
    }: { documentId: number; settings: PendingDocumentSettings }
  ) {
    state.documentSettings[documentId] = settings;
    state.apiState.getDocumentSettings.loading = false;
    state.apiState.getDocumentSettings.success = true;
  },
  GET_DOCUMENT_SETTINGS_ERROR(state: PendingDocumentsState, error: Error) {
    state.apiState.getDocumentSettings.loading = false;
    state.apiState.getDocumentSettings.error = error;
  },

  // Update document settings mutations
  UPDATE_DOCUMENT_SETTINGS_LOADING(state: PendingDocumentsState) {
    state.apiState.updateDocumentSettings.loading = true;
    state.apiState.updateDocumentSettings.success = false;
    state.apiState.updateDocumentSettings.error = null;
  },
  UPDATE_DOCUMENT_SETTINGS_SUCCESS(
    state: PendingDocumentsState,
    {
      documentId,
      settings
    }: { documentId: number; settings: Partial<PendingDocumentSettings> }
  ) {
    // Merge the updated settings with existing settings
    if (!state.documentSettings[documentId]) {
      state.documentSettings[documentId] = {
        tags: [],
        searchDate: '',
        ...settings
      };
    } else {
      state.documentSettings[documentId] = {
        ...state.documentSettings[documentId],
        ...settings
      };
    }
    state.apiState.updateDocumentSettings.loading = false;
    state.apiState.updateDocumentSettings.success = true;
  },
  UPDATE_DOCUMENT_SETTINGS_ERROR(state: PendingDocumentsState, error: Error) {
    state.apiState.updateDocumentSettings.loading = false;
    state.apiState.updateDocumentSettings.error = error;
  },

  // Project settings mutations
  GET_PROJECT_SETTINGS_LOADING(state: PendingDocumentsState) {
    state.apiState.getProjectSettings.loading = true;
    state.apiState.getProjectSettings.success = false;
    state.apiState.getProjectSettings.error = null;
  },
  GET_PROJECT_SETTINGS_SUCCESS(
    state: PendingDocumentsState,
    {
      documentId,
      settings
    }: { documentId: number; settings: PendingProjectSettings }
  ) {
    state.projectSettings[documentId] = settings;
    state.apiState.getProjectSettings.loading = false;
    state.apiState.getProjectSettings.success = true;
  },
  GET_PROJECT_SETTINGS_ERROR(state: PendingDocumentsState, error: Error) {
    state.apiState.getProjectSettings.loading = false;
    state.apiState.getProjectSettings.error = error;
  },

  // Update project settings mutations
  UPDATE_PROJECT_SETTINGS_LOADING(state: PendingDocumentsState) {
    state.apiState.updateProjectSettings.loading = true;
    state.apiState.updateProjectSettings.success = false;
    state.apiState.updateProjectSettings.error = null;
  },
  UPDATE_PROJECT_SETTINGS_SUCCESS(
    state: PendingDocumentsState,
    {
      documentId,
      settings
    }: { documentId: number; settings: Partial<PendingProjectSettings> }
  ) {
    // Merge the updated settings with existing settings
    if (!state.projectSettings[documentId]) {
      state.projectSettings[documentId] = {
        projectTitle: '',
        primaryResearchNode: undefined,
        researchNodes: [],
        ...settings
      };
    } else {
      state.projectSettings[documentId] = {
        ...state.projectSettings[documentId],
        ...settings
      };
    }
    state.apiState.updateProjectSettings.loading = false;
    state.apiState.updateProjectSettings.success = true;
  },
  UPDATE_PROJECT_SETTINGS_ERROR(state: PendingDocumentsState, error: Error) {
    state.apiState.updateProjectSettings.loading = false;
    state.apiState.updateProjectSettings.error = error;
  },

  // Clear project settings for a specific document (for cache invalidation)
  CLEAR_PROJECT_SETTINGS(state: PendingDocumentsState, documentId: number) {
    if (state.projectSettings[documentId]) {
      delete state.projectSettings[documentId];
    }
  }
};
